module.exports = __webpack_public_path__ + "img/a.1c123194.jpg";